'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SYSTEM_ID = exports.SYSTEM_ID = 'SYSTEM_ID';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/SenderIds.js
// module id = 111
// module chunks = 2 3